import { ChangeEvent, useState } from "react"

const useStateHandler = <T extends Record<string, unknown>>(
   initialState: T
) => {
   const [state, setState] = useState<T>(initialState)

   const handleChange = (
      e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
   ) => {
      const { name, value } = e.target
      setState((prevState) => ({
         ...prevState,
         [name]: value,
      }))
   }

   return [state, handleChange] as const
}

export default useStateHandler
